import { Color } from "capitalrx-components-2.0/lib/general";
import styled, { css } from "styled-components";

// Standalone PhoneNumberInputs
import { default as PhoneInputWithCountry } from "react-phone-number-input";
import { default as PhoneInputWithoutCountry } from "react-phone-number-input/input";
// react-hook-form PhoneNumberInputs
import { default as RHFPhoneInputWithCountry } from "react-phone-number-input/react-hook-form";
import { default as RHFPhoneInputWithoutCountry } from "react-phone-number-input/react-hook-form-input";
import "react-phone-number-input/style.css";

/**
 * The phone library we're using here only renders an unstyled
 * html input when not using the country code so we must style it differently
 */
const baseInputStyles = css`  
    font: inherit;
    color: inherit;
    text-decoration: inherit;
    line-height: inherit;

    padding: 0.5rem;
    margin: 0;
    width: 100%;
    transition: border-color 0.2s ease;

    background-color: ${Color.toString(Color.White)};
    border: solid 1px ${Color.toString(Color.LightGrey[300])};
    border-radius: 0.25rem;

    &::placeholder,
    &:-ms-input-placeholder,
    &::-ms-input-placeholder {
      color: ${Color.toString(Color.LightGrey[400])}
    }

    &:focus,
    &:hover {
      outline: none;
    }

    &.invalid {
      border-color: ${Color.toString(Color.Red[600])};
    }

    &:read-only {
      background-color: ${Color.toString(Color.LightGrey[100])};
      border-color: ${Color.toString(Color.LightGrey[100])};
    }

    &:disabled {
      background-color: ${Color.toString(Color.LightGrey[200])};
      border-color: ${Color.toString(Color.LightGrey[200])};
      color: transparent;

      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: transparent;
      }
    }

    &:not(:disabled) {
      &:not(:read-only) {
        &:focus {
          border-color: ${Color.toString(Color.Turqoise[400])};
        }

        &:hover {
          border-color: ${Color.toString(Color.LightGrey[700])};
        }
      }
    }
`;
/**
 * A styled version of the react-phone-number-input component.
 */

const basePhoneNumberInputStyles = css`
  .PhoneInputCountry {
    padding: 8px 9px;
    background-color: ${Color.toString(Color.White)};
    border: solid 1px ${Color.toString(Color.LightGrey[300])};
    border-right-width: 0;
    border-radius: 0.25rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 0;
  }
  .PhoneInputCountrySelectArrow {
    width: 0;
    height: 0;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 4px 4px 0 4px;
    border-color: ${Color.toString(Color.LightGrey[700])} transparent transparent transparent;
    transform: none;
    margin-left: 8px;
  }
  input.PhoneInputInput {
    ${baseInputStyles}
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
export const StyledPhoneInputWithCountry = styled(PhoneInputWithCountry)`
  ${basePhoneNumberInputStyles}
`;

export const StyledPhoneInputWithoutCountry = styled(PhoneInputWithoutCountry)`
  ${baseInputStyles}
`;
export const StyledRHFPhoneInputWithCountry = styled(RHFPhoneInputWithCountry)`
  ${basePhoneNumberInputStyles}
`;
export const StyledRHFPhoneInputWithoutCountry = styled(RHFPhoneInputWithoutCountry)`
  ${baseInputStyles}
`;
